import React from 'react'
import '../../resources/styles/bulma.sass';

const App = props => <>{props.children}</>;

export default App;

